import pkg from "../../package.json";

export function getSvgSpriteName(): string {
  return `sprite.svg?v=${pkg.version}`;
}
